import Cookie from 'js-cookie';
import { fetchJson } from '../utils/http';
export const getReferralData = (userOid, campaignNanoid) => fetchJson(`/api/v1/referrals/users/${userOid}/campaigns/${campaignNanoid}/`, {
  headers: {
    'X-CSRFToken': Cookie.get('csrftoken') || ''
  }
}).then(res => res);